var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c("div", { class: _vm.$style.containerHeader }, [_vm._t("header")], 2),
    _vm._v(" "),
    _c("div", { class: _vm.containerStyles }, [_vm._t("default")], 2),
    _vm._v(" "),
    _c("div", { class: _vm.$style.containerFooter }, [_vm._t("footer")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/mobile/components/MobileContainer.vue?vue&type=template&id=cc511fa2&
// module id = null
// module chunks = 